
import Shaka from 'shaka-player/dist/shaka-player.ui'

class FullscreenMenuButton extends Shaka.ui.Element {
  constructor(parent, controls, buttonHandler) {
    super(parent, controls)

    const fullscreen_button = document.createElement('button')
    fullscreen_button.classList.add('shaka-no-propagation')
    fullscreen_button.classList.add('material-icons', 'mdi', 'mdi-fullscreen')
    this.parent.appendChild(fullscreen_button)

    this._buttonHandler = () => buttonHandler(this)
    this._fullscreenButton = fullscreen_button

    this.eventManager.listen(this._fullscreenButton, 'click', this._buttonHandler)
  }

  /**
   * フルスクリーンアイコンの切り替え
   * @param {Boolean} fullscreenEnabled
   */
  toggleFullscreenIcon(fullscreenEnabled) {
    if (fullscreenEnabled) {
      this._fullscreenButton.classList.remove('mdi-fullscreen')
      this._fullscreenButton.classList.add('mdi-fullscreen-exit')
    } else {
      this._fullscreenButton.classList.remove('mdi-fullscreen-exit')
      this._fullscreenButton.classList.add('mdi-fullscreen')
    }
  }
}

FullscreenMenuButton.Factory = class {
  constructor(buttonHandler) {
    this._buttonHandler = buttonHandler
  }

  create(rootElement, controls) {
    return new FullscreenMenuButton(rootElement, controls, this._buttonHandler)
  }
}

export default FullscreenMenuButton
